// extracted by mini-css-extract-plugin
module.exports = {"search-results":"_3KAJu","searchResults":"_3KAJu","show-more-results-btn":"zXnoe","showMoreResultsBtn":"zXnoe"};